/**
 * The content list is a cache of one server read, refetched by every page that
 * shows it. Persisting it only brought rows from an older build back before
 * that refetch, so it starts empty on every load instead.
 */
const EMPTY_LISTS = { contents: [], numContents: [] };

/**
 * Keys an older build persisted and nothing reads any more — `users` was an
 * account cache — dropped on load so the next save purges them.
 */
const RETIRED_KEYS = ['users', 'ageRanges'];

const withoutCachedLists = (state) => {
  if (!state || !state.data || !state.data.data) {
    return state;
  }
  const lists = { ...state.data.data, ...EMPTY_LISTS };
  RETIRED_KEYS.forEach((key) => delete lists[key]);
  return { ...state, data: { ...state.data, data: lists } };
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined
    }
    return withoutCachedLists(JSON.parse(serializedState));
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(withoutCachedLists(state));
    localStorage.setItem('state', serializedState);
  } catch (err){
    console.log(`err: `, err);
  }
}
